import { render, staticRenderFns } from "./CreditsSummary.vue?vue&type=template&id=1a26faa0"
import script from "./CreditsSummary.vue?vue&type=script&lang=js"
export * from "./CreditsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports